export const seoPages = [
  {
    slug: "english-to-spanish-subtitle-generator",
    type: "landing",
    title: "English to Spanish Subtitle Generator for Videos",
    metaTitle: "English to Spanish Subtitle Generator for Videos | SubtitleTsunami",
    metaDescription:
      "Generate English to Spanish subtitles for videos with AI. Upload your video, create Spanish subtitles, and download your finished subtitled video.",
    h1: "English to Spanish Subtitle Generator for Videos",
    excerpt:
      "Upload an English video and generate Spanish subtitles with SubtitleTsunami.",
    primaryKeyword: "English to Spanish subtitle generator",
    datePublished: "2026-05-14",
    dateModified: "2026-05-14",
    canonicalPath: "/english-to-spanish-subtitle-generator",
  },
  {
    slug: "how-to-add-spanish-subtitles-to-video",
    type: "blog",
    title: "How to Add Spanish Subtitles to an English Video",
    metaTitle: "How to Add Spanish Subtitles to an English Video | SubtitleTsunami",
    metaDescription:
      "Learn how to add Spanish subtitles to an English video. Upload your video, generate English-to-Spanish subtitles, and download your subtitled file.",
    h1: "How to Add Spanish Subtitles to an English Video",
    excerpt:
      "A simple guide for creators who want to add Spanish subtitles to English videos.",
    primaryKeyword: "how to add Spanish subtitles to a video",
    datePublished: "2026-05-14",
    dateModified: "2026-05-14",
    canonicalPath: "/how-to-add-spanish-subtitles-to-video",
  },
  {
    slug: "translate-youtube-shorts-to-spanish-subtitles",
    type: "blog",
    title: "How to Translate YouTube Shorts into Spanish Subtitles",
    metaTitle: "How to Translate YouTube Shorts into Spanish Subtitles | SubtitleTsunami",
    metaDescription:
      "Learn how to translate YouTube Shorts into Spanish subtitles so your short-form videos can reach more Spanish-speaking viewers.",
    h1: "How to Translate YouTube Shorts into Spanish Subtitles",
    excerpt:
      "A guide for creators who want to turn English YouTube Shorts into Spanish-subtitled videos.",
    primaryKeyword: "translate YouTube Shorts into Spanish subtitles",
    datePublished: "2026-05-14",
    dateModified: "2026-05-14",
    canonicalPath: "/translate-youtube-shorts-to-spanish-subtitles",
  },
  {
    slug: "add-spanish-captions-to-tiktok-instagram-reels",
    type: "blog",
    title: "How to Add Spanish Captions to TikTok and Instagram Reels",
    metaTitle: "How to Add Spanish Captions to TikTok and Instagram Reels | SubtitleTsunami",
    metaDescription:
      "Learn how to add Spanish captions to TikTok videos and Instagram Reels using an AI subtitle generator.",
    h1: "How to Add Spanish Captions to TikTok and Instagram Reels",
    excerpt:
      "A simple guide for adding Spanish captions to short-form social videos.",
    primaryKeyword: "add Spanish captions to TikTok and Instagram Reels",
    datePublished: "2026-05-14",
    dateModified: "2026-05-14",
    canonicalPath: "/add-spanish-captions-to-tiktok-instagram-reels",
  },
  {
    slug: "why-spanish-subtitles-help-videos-reach-more-viewers",
    type: "blog",
    title: "Why Spanish Subtitles Help Videos Reach More Viewers",
    metaTitle: "Why Spanish Subtitles Help Videos Reach More Viewers | SubtitleTsunami",
    metaDescription:
      "Spanish subtitles can help English videos become easier to understand, easier to share, and more useful for Spanish-speaking audiences.",
    h1: "Why Spanish Subtitles Help Videos Reach More Viewers",
    excerpt:
      "Why creators should consider adding Spanish subtitles to English videos.",
    primaryKeyword: "why Spanish subtitles help videos reach more viewers",
    datePublished: "2026-05-14",
    dateModified: "2026-05-14",
    canonicalPath: "/why-spanish-subtitles-help-videos-reach-more-viewers",
  },
];

export const getSeoPageBySlug = (slug) => {
  return seoPages.find((page) => page.slug === slug);
};